import { io } from 'socket.io-client';

const URL =
  process.env.NODE_ENV === 'production'
    ? window.location.origin 
    : 'http://localhost:3000';

const userID = localStorage.getItem('userID');
const roomname = localStorage.getItem('roomname');
const username = localStorage.getItem('username');

export const socket = io(URL, {
  path: process.env.NODE_ENV === 'production' ? '/backend/socket.io' : undefined,
  query: { token: 'client' },
  auth: { username, userID, roomname },
  autoConnect: true
});
